import AiReportsAPI from '../../api/aiReports';

const EMPTY = {
  conversations: { total: 0, timeseries: [] },
  leads: {
    total: 0,
    by_status: {},
    by_category: {},
    timeseries: [],
    top_service_interests: [],
    top_platforms: [],
  },
  kb: { top_articles: [], miss_count: 0 },
};

export const state = {
  data: { ...EMPTY },
  uiFlags: { isFetching: false },
};

export const getters = {
  getData(_state) {
    return _state.data;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }, params = {}) => {
    commit('SET_AI_REPORT_UI_FLAG', { isFetching: true });
    try {
      const { data } = await AiReportsAPI.getOverview(params);
      commit('SET_AI_REPORT', data);
    } finally {
      commit('SET_AI_REPORT_UI_FLAG', { isFetching: false });
    }
  },
};

export const mutations = {
  SET_AI_REPORT_UI_FLAG(_state, uiFlags) {
    _state.uiFlags = { ..._state.uiFlags, ...uiFlags };
  },
  SET_AI_REPORT(_state, data) {
    _state.data = { ...EMPTY, ...data };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
